export default __webpack_public_path__ + "static/media/miniexcavator.45c7fcf0.jpg";